import { Component, OnInit, Input} from '@angular/core';
import {Reservation} from '../../api/model/reservation/reservation.model';
import {Hotel} from '../../api/model/hotel/hotel.model';

@Component({
  selector: 'stay-mgmt-hotel-reservation-details',
  templateUrl: './hotel-reservation-details.component.html',
  styleUrls: ['./hotel-reservation-details.component.scss']
})
export class HotelReservationDetailsComponent implements OnInit {

  @Input() messages;
  @Input() reservation: Reservation;
  @Input() hotel: Hotel;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-reservation-details/hotel-reservation-details.component.ts